import { CollaboratorPermissionType } from './Collaborator';
import { Member } from './Member';
import { Subteam } from './Subteam';
import { Team } from './Team';
import { Workspace } from './Workspace';

export enum TeamResourceAccessPrincipalType {
    TEAM = 'Team',
    SUBTEAM = 'Subteam',
}

export enum TeamResourceAccessResourceType {
    FOLDER = 'Folder',
    INVESTMENT = 'Investment',
    MEMO = 'Memo',
    PIPELINE = 'Pipeline',
    DASHBOARD = 'Dashboard',
    LIST = 'List',
    LIFECYCLE = 'Lifecycle',
}

export enum TeamResourceAccessStatusType {
    ACTIVE = 'Active',
    REVOKED = 'Revoked',
}

export interface TeamResourceAccess {
    id: string;
    workspace: Workspace;
    principalType: TeamResourceAccessPrincipalType;
    team?: Team;
    subteam?: Subteam;
    resourceType: TeamResourceAccessResourceType;
    resourceId: string;
    permission: CollaboratorPermissionType;
    status: TeamResourceAccessStatusType;
    grantedBy?: Member;
    createdAt: Date;
    updatedAt: Date;
}
